import getApi from '../../api/apisauceConfig'
import { singleItemPageLimit } from '../../constants'
import { Country } from '../../model/Contact'
import { Filters } from '../../model/Filters'
import { PaginatedList } from '../../model/Pagination'

export const getCountries = (
  page: number,
  filters?: Filters,
  signal?: AbortSignal,
  limit = singleItemPageLimit,
) =>
  getApi().get<PaginatedList<Country>>(
    '/countries',
    {
      page,
      limit,
      ...filters,
    },
    { signal },
  )
